import { render, staticRenderFns } from "./CardImage.vue?vue&type=template&id=703c7155&scoped=true"
import script from "./CardImage.vue?vue&type=script&lang=js"
export * from "./CardImage.vue?vue&type=script&lang=js"
import style0 from "./CardImage.vue?vue&type=style&index=0&id=703c7155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c7155",
  null
  
)

export default component.exports